// extracted by mini-css-extract-plugin
export var boldText = "_5s-4";
export var checkboxContainer = "_5s-6";
export var closeIcon = "_5s-i";
export var container = "_5s-0";
export var drawer = "_5s-8";
export var drawerContent = "_5s-9";
export var extraSmallText = "_5s-5";
export var fulfillmentGroupTable = "_5s-e";
export var largeText = "_5s-3";
export var loadingSpinnerContainer = "_5s-j";
export var mediumText = "_5s-2";
export var narrow = "_5s-f";
export var notificationLink = "_5s-l";
export var packageCheckIconContainer = "_5s-7";
export var slideoutHeaderActions = "_5s-g";
export var slideoutHeaderActionsShifted = "_5s-h";
export var slideoutHeaderContainer = "_5s-a";
export var slideoutModal = "_5s-c";
export var stickyHeaderWrapper = "_5s-b";
export var table = "_5s-k";
export var tableContainer = "_5s-d";
export var tertiaryText = "_5s-1";